/* eslint-disable react/display-name */
import React from 'react';

export const CustomerProfileContext = React.createContext(null);

const withCustomerProfileContext = WrappedComponent => (props) => (
  <CustomerProfileContext.Consumer>
    {({ showSignup, loginState, customer }) => (
      <WrappedComponent
        {...props}
        showSignup={showSignup}
        loginState={loginState}
        customer={customer}
      />
    )
    }
  </CustomerProfileContext.Consumer>
);

export default withCustomerProfileContext;
